export const isDevMode = () => process.env.NODE_ENV === 'development';

// need to check another variable, as REACT app will auto set to production in build mode. 🙄
// https://create-react-app.dev/docs/deployment/#customizing-environment-variables-for-arbitrary-build-environments
export const isTestMode = () => process.env.NODE_ENV === 'test' || process.env.REACT_APP_DEPLOY_ENV === 'test';

export const isProdMode = () => process.env.NODE_ENV === 'production' && process.env.REACT_APP_DEPLOY_ENV !== 'test';
